import { ParticipantRoleEnum } from '../models/partipant.model';
import { BehaviorSubject } from 'rxjs';
import { W3StorageService } from '@rapi/w3/apps/storage';
import { GraphChangedData, SessionPanel } from '@sip/common/models';
import { SipSocketService } from '@sip/common/web-socket/sip-socket.service';
import { AlertAllParticipants, MessageRegistered, PostChanged, ProjectChangedConfig } from '../events';
import { ClearDataEvent } from './events';
import * as i0 from "@angular/core";
import * as i1 from "../../../@sip/common/web-socket/sip-socket.service";
import * as i2 from "../../../@rapi/w3/apps/storage/storage.service";
var SessionConfigService = /** @class */ (function () {
    // private _config: ConfigSessionModel = {
    //
    //     ///
    //     type: 'privada', // privada publica restrita
    //     enable_forward: true,
    //     apresentation_type: 'keypad', // keypag slide
    //     enable_change_view: false,
    //     enable_countdown: true,
    //     has_feedback: true
    // };
    function SessionConfigService(socket, storage) {
        this.socket = socket;
        this.storage = storage;
        this.info = {
            view: null
        };
        this.participantSubject = new BehaviorSubject(null);
        this.sessionSubject = new BehaviorSubject(null);
        this.broadCastSubject = new BehaviorSubject(null);
        this.participant$ = this.participantSubject.asObservable();
        this.session$ = this.sessionSubject.asObservable();
        this.broadCast$ = this.broadCastSubject.asObservable();
    }
    SessionConfigService.prototype.current = function () {
        return this.sessionSubject.getValue();
    };
    SessionConfigService.prototype.participant = function () {
        return this.participantSubject.getValue();
    };
    // Modo representativo, com opção avançada de selecionar uma ou mais unidades por vez (contrario ao modo simples
    SessionConfigService.prototype.isRepresentativePro = function () {
        var p = this.participant();
        var s = this.current();
        return p && p.role === ParticipantRoleEnum.REPRESENTATIVE && !s.simple_representative;
    };
    // Modo representativo, permitindo apenas enviar voto para todas as unidades de uma vez
    SessionConfigService.prototype.isRepresentativeSimple = function () {
        var p = this.participant();
        var s = this.current();
        return p && p.role === ParticipantRoleEnum.REPRESENTATIVE && s.simple_representative;
    };
    SessionConfigService.prototype.disableSocket = function () {
        this.channel = null;
        this.socket.reset();
    };
    SessionConfigService.prototype.configureSocket = function () {
        var _this = this;
        this.disableSocket();
        var sessionId = this.current().id;
        var participantId = this.participant().id;
        var nameChSession = "vis.session." + sessionId;
        var nameChParticipant = "vis.participant." + participantId;
        this.socket.connect();
        this.channel = this.socket.joinChannel(nameChSession);
        this.channel
            .listen('AlertAllParticipants', function (e) {
            _this.broadCastSubject.next(new AlertAllParticipants(e.payload));
        });
        this.channel
            .listen('ProjectChangedConfig', function (e) {
            _this.broadCastSubject.next(new ProjectChangedConfig(e.payload));
        });
        this.channel
            .listen('SessionPanel', function (e) {
            _this.broadCastSubject.next(new SessionPanel(e));
        });
        this.channel
            .listen('GraphChangedData', function (e) {
            _this.broadCastSubject.next(new GraphChangedData(e));
        });
        // Página (post) alterada no painel — usa broadcastAs('post.changed'),
        // por isso o nome do evento no Echo leva o prefixo ".".
        this.channel
            .listen('.post.changed', function (e) {
            _this.broadCastSubject.next(new PostChanged(e.payload));
        });
        this.socket
            .createPrivateChannel(nameChParticipant)
            .listen('MessageRegistered', function (e) {
            _this.broadCastSubject.next(new MessageRegistered(e.data.message, e.data.action));
        });
    };
    SessionConfigService.prototype.dispatchClearData = function () {
        this.broadCastSubject.next(new ClearDataEvent());
    };
    SessionConfigService.prototype.hasOtherSeason = function (code, id) {
        var currentId = +this.storage.get('session_id');
        var currentCode = this.storage.get('session_code');
        var checkId = +id;
        if (currentId > 0 && checkId > 0 && currentId !== checkId) {
            return true;
        }
        return currentCode && currentCode !== code;
    };
    SessionConfigService.prototype.activate = function (session) {
        this.storage.set('session_id', session.id);
        this.storage.set('session_code', session.code);
        this.sessionSubject.next(session);
    };
    SessionConfigService.prototype.setParticipant = function (participant) {
        if (participant) {
            this.checkSessionZoom();
        }
        this.participantSubject.next(participant);
        this.configureSocket();
    };
    SessionConfigService.prototype.isPrivate = function () {
        return this.identify === 'private';
    };
    SessionConfigService.prototype.isPublic = function () {
        return this.identify === 'public';
    };
    SessionConfigService.prototype.isAnonymous = function () {
        return this.identify === 'anonymous';
    };
    SessionConfigService.prototype.isRestrict = function () {
        return this.identify === 'restricted';
    };
    Object.defineProperty(SessionConfigService.prototype, "identify", {
        get: function () {
            return this.current() ? this.current().identify : 'restricted';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SessionConfigService.prototype, "type", {
        get: function () {
            return this.current() ? this.current().type : 'poll';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SessionConfigService.prototype, "isPoll", {
        get: function () {
            return this.type === 'poll';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SessionConfigService.prototype, "code", {
        get: function () {
            return this.current() ? this.current().code : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SessionConfigService.prototype, "name", {
        get: function () {
            return this.current() ? this.current().name : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SessionConfigService.prototype, "msgOrg", {
        get: function () {
            if (this.current() && this.current().metas) {
                return this.current().metas.msg_inicio;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SessionConfigService.prototype, "msgWait", {
        get: function () {
            if (this.current() && this.current().metas) {
                return this.current().metas.msg_aguarde;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SessionConfigService.prototype, "metas", {
        // ----- Configurações do modo Prova (assíncrono / type=test) -----
        get: function () {
            var s = this.current();
            return s && s.metas ? s.metas : null;
        },
        enumerable: true,
        configurable: true
    });
    // Coerção defensiva: o backend pode enviar bool nativo, 1/0 ou "1"/"true".
    SessionConfigService.prototype.metaBool = function (value, def) {
        if (value === undefined || value === null || value === '') {
            return def;
        }
        return value === true || value === 1 || value === '1' || value === 'true';
    };
    Object.defineProperty(SessionConfigService.prototype, "showFinishButton", {
        // 2.2 - exibe o botão de FIM no app (default: true)
        get: function () {
            return this.metaBool(this.metas ? this.metas.test_show_finish_button : undefined, true);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SessionConfigService.prototype, "finishButtonText", {
        // 2.2 - texto customizável do botão de FIM (default: "FIM")
        get: function () {
            return this.metas && this.metas.test_finish_button_text ? this.metas.test_finish_button_text : 'FIM';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SessionConfigService.prototype, "showSummaryPage", {
        // 2.3 - ao clicar em FIM vai para a página de resumo (gabarito) (default: false)
        get: function () {
            return this.metaBool(this.metas ? this.metas.test_show_summary_page : undefined, false);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SessionConfigService.prototype, "showConclusionPage", {
        // 2.4 - ao concluir, exibe página de conclusão em vez de logout (default: false)
        get: function () {
            return this.metaBool(this.metas ? this.metas.test_show_conclusion_page : undefined, false);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SessionConfigService.prototype, "conclusionPageId", {
        // 2.4 - id da página de conclusão a exibir ao finalizar (modo prova)
        get: function () {
            return this.metas ? this.metas.test_conclusion_page_id : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SessionConfigService.prototype, "showAnswersCounter", {
        // 2.5 - exibe contador de respostas no canto inferior direito (default: false)
        get: function () {
            return this.metaBool(this.metas ? this.metas.test_show_answers_counter : undefined, false);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SessionConfigService.prototype, "allowRetake", {
        // 2.6 - modo prova com retrocesso: permite refazer a prova e reenviar votos
        // mesmo após finalizar. Espelha o test_regress_enable do backend, que libera
        // a votação de um participante já finalizado (default: false).
        get: function () {
            return this.metaBool(this.metas ? this.metas.test_regress_enable : undefined, false);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SessionConfigService.prototype, "isOpen", {
        get: function () {
            return this.current() ? this.current().status : false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SessionConfigService.prototype, "typeView", {
        get: function () {
            return this.current() ? this.current().view : null;
        },
        enumerable: true,
        configurable: true
    });
    SessionConfigService.prototype.openSession = function () {
        var session = this.current();
        session.status = true;
        this.activate(session);
    };
    // Fecha a sessão localmente (status=false) mantendo-a ativa no estado, sem
    // reset()/logout — usado no poll para o participante voltar à tela de aguarde
    // e poder reabrir quando o admin iniciar de novo.
    SessionConfigService.prototype.closeSession = function () {
        var session = this.current();
        if (!session) {
            return;
        }
        session.status = false;
        this.activate(session);
    };
    // se possui um USER ATIVO
    SessionConfigService.prototype.check = function () {
        return !!this.participant();
    };
    // Convidado ( não logado )
    SessionConfigService.prototype.guest = function () {
        return !this.check();
    };
    SessionConfigService.prototype.reset = function () {
        this.disableSocket();
        this.participantSubject.next(null);
        // this.participantSubject.complete();
        this.sessionSubject.next(null);
        // this.sessionSubject.complete();
        this.broadCastSubject.next(null);
        // this.broadCastSubject.complete();
        this.storage.remove('session_id');
        this.storage.remove('session_code');
    };
    SessionConfigService.prototype.checkSessionZoom = function () {
        var session = this.current();
        // check is session with zoom AND Check if a Page Is Not in an iFrame
        if (session.zoom_enable && window.location === window.parent.location) {
            window.location.replace(window.location.origin + "/zoom/");
        }
    };
    SessionConfigService.ngInjectableDef = i0.defineInjectable({ factory: function SessionConfigService_Factory() { return new SessionConfigService(i0.inject(i1.SipSocketService), i0.inject(i2.W3StorageService)); }, token: SessionConfigService, providedIn: "root" });
    return SessionConfigService;
}());
export { SessionConfigService };
